export enum SecureConfirmType {
  TwoFA = 'two_fa',
  Password = 'password',
}
